<template>
  <div class="notice-wrap">
    <div class="notice">
      <img src="@/assets/images/img_sytemNotice.svg" alt="">
      <h2 class="header">페이지를 찾을 수 없습니다.</h2>
      <p>존재하지 않는 주소를 입력하셨거나<br>요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
    error: Error,
});

// 2초 후에 메인 페이지로 이동
setTimeout(() => {
  console.log('[error.vue] 에러 도착:', props.error)
  if(import.meta.client ){
    navigateTo('/');
  }
}, 2000);
</script>
   
<style lang="scss" scoped>
.notice-wrap{
  height: 100vh;
  display: flex;
  justify-content: center;
}
.notice{
  margin: auto 0;
  padding: 5rem;
  font-size: 2.2rem;
  font-weight: normal;
  text-align: center;
  img{
    width: 31rem;
    margin-bottom: 4rem;
  }
  p{
    margin: 0;
  }
  .header{
    font-size: 4.6rem;
    letter-spacing: -0.03em;
    margin-bottom: 1rem;
  }
  .time{
    margin: 4rem 0;
    padding: 1.5rem;
    display: inline-block;
    width: 48rem;
    background-color: #f6f6f6;
    font-size: 3rem;
    font-weight: bold;
    color: #2151d5;
  }
  .footer{
    margin-top: 4rem;
  }
}
</style>
